import React from 'react';
import { Dropdown } from 'antd';

const CustomContextMenu = ({ canOpenDocuments, number, item, onCopy, onOpenPanel, children }) => {

  const handleCopy = () => {
    onCopy(number);
  };

  const handleOpenPanel = () => {
    if (item) {
        onOpenPanel(item)
    }
  }

  const items = [
    {
      key: 1,
      label: 
            <div className='menu-item display-center' >
                <i className='ri-file-copy-2-line' />
                <div style={{ marginLeft: "4px" }}>Copy</div>
            </div>,
      onClick: (e) => {
        e.stopPropagation();
        handleCopy();
      }
    },
    item && canOpenDocuments && {
      key: 2,
      label: 
      <div className='menu-item display-center' >
          <i className='ri-article-line' />
          <div style={{ marginLeft: "4px" }}>Document Detail</div>
      </div>,
      onClick: () => handleOpenPanel()
    },
  ];

  return (
    <Dropdown
        menu={{items}}
        trigger={['contextMenu']}
    >
        <div>
            {children}
        </div>
    </Dropdown>
  );
};

export default CustomContextMenu;